import { wait } from "../common/helpers";
import styles from "../../css/footer.pcss.json";

// noinspection JSUnusedGlobalSymbols
export default async (_elements: NodeListOf<HTMLElement>, setDetach: (detach: () => void) => void) => {
  const setFirstRowItems = async () => {
    document.querySelectorAll<HTMLAnchorElement>(`.${styles['site-menu__subnav__item--first-in-row']}`).forEach(item => {
      item.classList.remove(styles['site-menu__subnav__item--first-in-row'])
    })

    document.querySelectorAll<HTMLDivElement>(`.${styles['site-menu--first-column']}`).forEach(item => {
      item.classList.remove(styles['site-menu--first-column'])
    })

    document.querySelectorAll<HTMLAnchorElement>(`.${styles['site-menu__subnav__item--last-in-row']}`).forEach(item => {
      item.classList.remove(styles['site-menu__subnav__item--last-in-row'])
    })

    let rowY = 0
    let colX = 0;
    let prevItem: HTMLElement;
    const items = document.querySelectorAll<HTMLAnchorElement>(`.${styles['site-menu__subnav__item']}`)
    for (let item of items) {
      if (rowY !== item.offsetTop) {
        item.classList.add(styles['site-menu__subnav__item--first-in-row'])
        window.getComputedStyle(item)
        if (item.offsetTop === rowY && prevItem) {
          prevItem.classList.add(styles['site-menu__subnav__item--last-in-row'])
        }
        window.getComputedStyle(item)
        rowY = item.offsetTop
      }
      prevItem = item
    }

    const items2 = document.querySelectorAll<HTMLDivElement>(`.${styles['site-menu']}`)
    for (let item of items2) {
      if (colX === 0) {
        colX = item.offsetLeft
      }

      if (item.offsetLeft === colX) {
        item.classList.add(styles['site-menu--first-column'])
      }
    }
  }

  window.addEventListener('resize', setFirstRowItems)

  setDetach(() => {
    window.removeEventListener('resize', setFirstRowItems)
  })

  await wait(1000)
  // noinspection ES6MissingAwait
  setFirstRowItems()
}
